module.exports = __webpack_public_path__ + "static/img/device_hy_s3.c9ae6994.png";